import { STATUS_LABEL } from "@/lib/format";
import { Bars } from "./Bars";

const ORDER = ["recebido", "visualizado", "resposta_preparada", "pendente_confirmacao", "respondido"];

const fmtWait = (s) => {
  if (s === null || s === undefined) return "—";
  if (s < 60) return "menos de 1 min";
  const m = Math.round(s / 60);
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  return h < 24 ? `${h} h ${m % 60} min` : `${Math.floor(h / 24)} d ${h % 24} h`;
};

export const Service = ({ s }) => (
  <div className="space-y-10">
    <dl data-testid="service-figures" className="grid grid-cols-2 border-y border-zap-line sm:grid-cols-3">
      {[["Atendimentos abertos", s.opened, "service-opened"], ["Com primeira resposta", s.replied_count, "service-replied"],
        ["Tempo médio até a 1ª resposta", fmtWait(s.avg_first_reply_seconds), "service-avg-wait"]].map(([l, v, id]) => (
        <div key={id} data-testid={id} className="px-3 py-4">
          <dt className="text-xs text-muted-foreground">{l}</dt>
          <dd className="font-display text-2xl font-semibold tabular-nums text-zap-ink">{v}</dd>
        </div>
      ))}
    </dl>
    <div className="grid gap-10 md:grid-cols-2">
      <Bars testId="service-by-status" title="Atendimentos por situação" labels={STATUS_LABEL} keepOrder
        data={ORDER.map((k) => [k, s.by_status[k] || 0])} />
      <Bars testId="service-by-staff" title="Respostas por membro da equipe" data={s.by_staff} />
    </div>
  </div>
);
